// extracted by mini-css-extract-plugin
export default {"banner":"SignInBanner_banner__tVh0R","message":"SignInBanner_message__jfG7k","signInBtn":"SignInBanner_signInBtn__I1Tp6","dismiss":"SignInBanner_dismiss__XaLdS"};